/**
 * @file reducers/Loader/constants.js
 * @copyright 2016 CBC/Radio-Canada. All rights reserved.
 */

/**
 * A constant representing the situation where there are no actions to
 * execute.
 */

export const ZERO_COUNT = 0;
